import React from "react";

type Props = {
    selectedId : string
    onChange   : callback
    id         : ID
}
export default class QuickSearch_ModalNavigation extends React.Component<Props> {

    onOptionClick = (id: ID, e: React.SyntheticEvent) => {
        e.stopPropagation();

        console.log(id)
        if (id === 'search') {
            gd.modal.hide();
            gd.goTo('search');
            return;
        }

        if (id !== this.props.id && this.props.onChange) this.props.onChange(id);
    }

    render() {

        const options = [
            {id: 'goto',    icon: 'ii5-lightning',  label: 'Quick Search',     selected: this.props.selectedId === 'goto'},
            // {id: 'recent',  icon: 'i5-recent-new', label: 'Recent',    selected: this.props.selectedId === 'recent'},
        ]

        if (gd.user.acl.canAdvancedSearch) {
            options.push({
                id          : 'search',
                icon        : 'i5-search',
                label       : 'Advanced Search',
                selected    : this.props.selectedId === 'search'
            })
        }

        return (
            <div className="ui5-navigation-modal">
                {_.map(options, o=>
                    <div key={o.id} className={Classes("item", {selected: o.selected})} onClick={this.onOptionClick.bind(this, o.id)}>
                        <div className={Classes("icon", o.icon)}/>
                        <div className="label">{o.label}</div>
                    </div>
                )}
            </div>
        )
    }
}